// THIS IS A WRAPPER ON IMMER
// IT ENSURES WE ALWAYS HAVE ENABLE MAP SET RUNNING

import { enableMapSet } from "immer";

// RUN HERE
enableMapSet();

// RE EXPORT WHAT WE NEED AFTER IT RUNS
export { immerable } from 'immer';
export { useImmer } from 'use-immer';
export type { Updater } from 'use-immer';